enum CreativeStatus {
  DRAFT = 'D',
  PENDING_APPROVAL = 'P',
  APPROVED = 'A',
  REJECTED = 'R',
  RETIRED = 'C',
  SUBMITTED = 'S',
}

export default CreativeStatus;
